import React from 'react'
import { useMultiSite } from 'msp-integrations'
import {
  DynamicTagType,
  DynamicComponentType,
  DynamicComponentPropTypes
} from './DynamicTag.types'
import Footnotes from '@atoms/Footnotes/Footnotes'
import Headline from '@atoms/Headline/Headline'
import Preline from '@atoms/Preline/Preline'
import Tag from '@atoms/Tag/Tag'
import DynamicLink from '@atoms/DynamicLink/DynamicLink'
import { ComponentMapping } from '@common-types/ComponentMapping'

const defaultComponentMapping: ComponentMapping = {
  Footnotes: Footnotes,
  Headline: Headline,
  Preline: Preline,
  Tag: Tag
}

const DynamicTagWithLink = (
  href: string,
  openInNewTab: boolean,
  isExternalLink: boolean,
  component: DynamicComponentType,
  props: DynamicComponentPropTypes
) => (
  <DynamicLink
    href={href}
    openInNewTab={openInNewTab}
    isExternalLink={isExternalLink}
  >
    {React.createElement(component, props)}
  </DynamicLink>
)

const DynamicTagWithOutLink = (component: DynamicComponentType, props: any) =>
  React.createElement(component, props)

export const BaseDynamicTag = (props: DynamicTagType): JSX.Element => {
  const componentMapping = defaultComponentMapping

  const data = props.data || props
  const component = componentMapping[data.componentTagName]

  if (typeof component !== 'undefined') {
    const { href = null, openInNewTab = false, isExternalLink = false } = data

    return (
      <>
        {data.isNavItem ? (
          <li>
            {href
              ? DynamicTagWithLink(
                  href,
                  openInNewTab,
                  isExternalLink,
                  component,
                  data
                )
              : DynamicTagWithOutLink(component, data)}
          </li>
        ) : (
          <>
            {href
              ? DynamicTagWithLink(
                  href,
                  openInNewTab,
                  isExternalLink,
                  component,
                  data
                )
              : DynamicTagWithOutLink(component, data)}
          </>
        )}
      </>
    )
  }

  return React.createElement(() => (
    <div>The component {data.componentTagName} has not been created yet.</div>
  ))
}

const DynamicTag = (props: DynamicTagType) => {
  const { buildUrl } = useMultiSite()

  const data = Object.assign({}, props.data || props || {})
  if (props.custom?.content?.href) {
    data.href = props.custom?.content?.href
  }

  if (data && data.href) {
    if (data.href === null || data.href === '#' || data.href === '') {
      data.href = '#'
    }

    if (!data.isExternalLink && data.href !== '/') {
      data.href = buildUrl(data.href)
    }
  }

  return <BaseDynamicTag data={data} />
}

export default DynamicTag
